import { render } from "./SubmitField.vue?vue&type=template&id=ff92658e&scoped=true&ts=true"
import script from "./SubmitField.vue?vue&type=script&lang=ts"
export * from "./SubmitField.vue?vue&type=script&lang=ts"

import "./SubmitField.vue?vue&type=style&index=0&id=ff92658e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/hekate/hekate/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff92658e"]])

export default __exports__